/* DADDY — purchase suggestions with a vintage green-phosphor glitch filter (1979 ship-computer screen look).
   Exposes window.MotherSuggest.show(types[], title, extraLink). No storage APIs. */
(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var wrap = document.getElementById("suggest");
  var grid = document.getElementById("suggestGrid");
  var head = document.getElementById("suggestTitle");
  var more = document.getElementById("suggestMore");
  if (!wrap || !grid) return;
  var src = wrap.getAttribute("data-src") || "data/products.json";
  var data = null, cards = [], running = false, visible = true;

  // phosphor ramp: black → deep green → bright green → near white
  var RAMP = [[2, 12, 5], [8, 48, 20], [24, 110, 48], [60, 190, 95], [125, 255, 154], [220, 255, 225]];
  var BAYER = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];

  function load() {
    if (data) return Promise.resolve(data);
    var inline = document.getElementById("mother-products");
    if (inline) { try { data = JSON.parse(inline.textContent); return Promise.resolve(data); } catch (e) {} }
    return fetch(src).then(function (r) { return r.json(); }).then(function (d) { data = d; return d; });
  }
  /* Live inventory + newest arrivals from the store's public Storefront API (no key, no customer data).
     Merges over the bundled snapshot; in-stock items sort first, then newest. */
  var SF = "https://boxerandbrief.com/api/2025-07/graphql.json", liveDone = {};
  function refreshLive(types) {
    var need = types.filter(function (t) { return !liveDone[t]; });
    if (!need.length || !window.fetch) return Promise.resolve();
    var q = "{" + need.map(function (t, i) {
      return "t" + i + ":products(first:14,sortKey:CREATED_AT,reverse:true,query:" + JSON.stringify("product_type:\"" + t + "\"") +
        "){nodes{title onlineStoreUrl availableForSale priceRange{minVariantPrice{amount}} featuredImage{url}}}";
    }).join(" ") + "}";
    var ctl = window.AbortController ? new AbortController() : null, to = setTimeout(function () { ctl && ctl.abort(); }, 5000);
    return fetch(SF, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ query: q }), signal: ctl && ctl.signal })
      .then(function (r) { return r.json(); }).then(function (j) {
        need.forEach(function (t, i) {
          var nodes = (j.data && j.data["t" + i] && j.data["t" + i].nodes) || [];
          var list = nodes.filter(function (x) { return x.onlineStoreUrl && x.featuredImage; }).map(function (x) {
            var u = x.featuredImage.url; return { t: x.title, u: x.onlineStoreUrl, img: u + (u.indexOf("?") < 0 ? "?" : "&") + "width=900",
              p: +x.priceRange.minVariantPrice.amount, ty: t, s: x.availableForSale ? 1 : 0 };
          });
          if (list.length) data.types[t] = list;
          liveDone[t] = 1;
        });
      }).catch(function () {}).then(function () { clearTimeout(to); });
  }
  function pick(types, n) {
    var pools = types.map(function (t) { return (data.types[t] || []).slice().sort(function (a, b) { return (b.s | 0) - (a.s | 0); }); }).filter(function (p) { return p.length; });
    var out = [], seen = {}, i = 0, guard = 0;
    while (out.length < n && pools.length && guard++ < 200) {
      var pool = pools[i % pools.length], k = (Math.random() * Math.min(pool.length, 10)) | 0, p = pool.splice(k, 1)[0];
      if (p && !seen[p.u]) { seen[p.u] = 1; out.push(p); }
      if (!pool.length) pools.splice(i % pools.length, 1); else i++;
    }
    return out;
  }

  var SW = 480, SH = 600;                              // card screen resolution (2x the old 240x300)
  function phosphor(img, W, H) {
    // low-res, posterized, dithered green monochrome
    var lw = Math.round(W / 2), lh = Math.round(H / 2);   // 240x300 dither grid: vintage but readable
    var c = document.createElement("canvas"); c.width = lw; c.height = lh;
    var g = c.getContext("2d");
    g.fillStyle = "#fff"; g.fillRect(0, 0, lw, lh);
    var s = Math.max(lw / img.width, lh / img.height), dw = img.width * s, dh = img.height * s;
    g.drawImage(img, (lw - dw) / 2, (lh - dh) / 2, dw, dh);
    try {
      var d = g.getImageData(0, 0, lw, lh), px = d.data;
      for (var y = 0; y < lh; y++) for (var x = 0; x < lw; x++) {
        var o = (y * lw + x) * 4;
        var l = (0.3 * px[o] + 0.59 * px[o + 1] + 0.11 * px[o + 2]) / 255;
        l = 1 - l;                                     // invert: product on white becomes glowing on black, like a CRT
        l = Math.min(1, Math.max(0, (l - 0.04) * 1.35));
        var t = l * (RAMP.length - 1) + (BAYER[(y & 3) * 4 + (x & 3)] / 16 - 0.5) * 0.9;
        var idx = Math.max(0, Math.min(RAMP.length - 1, Math.round(t))), r = RAMP[idx];
        px[o] = r[0]; px[o + 1] = r[1]; px[o + 2] = r[2]; px[o + 3] = 255;
      }
      g.putImageData(d, 0, 0);
    } catch (e) { // no pixel access: fall back to CSS-style filters
      g.globalCompositeOperation = "multiply"; g.fillStyle = "#7dff9a"; g.fillRect(0, 0, lw, lh);
    }
    var big = document.createElement("canvas"); big.width = W; big.height = H;
    var bg = big.getContext("2d"); bg.imageSmoothingEnabled = false; bg.drawImage(c, 0, 0, W, H);
    return big;
  }

  function makeCard(p, i) {
    var a = document.createElement("a");
    a.className = "sg-card"; a.href = p.u; a.target = "_top";
    var cv = document.createElement("canvas"); cv.width = SW; cv.height = SH; cv.className = "sg-screen";
    cv.setAttribute("role", "img"); cv.setAttribute("aria-label", p.t);
    var meta = document.createElement("div"); meta.className = "sg-meta";
    var name = document.createElement("span"); name.className = "sg-name"; name.textContent = p.t.toUpperCase();
    var row = document.createElement("span"); row.className = "sg-row";
    row.innerHTML = '<span class="sg-code">ITEM ' + String(101 + i) + '</span>' + (p.s ? '' : '<span class="sg-soon">CUMMING SOON</span>') + '<span class="sg-price">$' + p.p.toFixed(0) + '</span>';
    meta.appendChild(name); meta.appendChild(row);
    var cta = document.createElement("span"); cta.className = "sg-cta"; cta.textContent = "[ INSPECT ]";
    a.appendChild(cv); a.appendChild(meta); a.appendChild(cta);
    var card = { el: a, cv: cv, ctx: cv.getContext("2d"), base: null, burst: 0, seed: Math.random() * 100, boot: 1 };
    a.addEventListener("mouseenter", function () { card.burst = 14; });
    a.addEventListener("focus", function () { card.burst = 14; });
    var img = new Image(); img.crossOrigin = "anonymous";
    img.onload = function () { card.base = phosphor(img, SW, SH); card.boot = 1; drawCard(card, performance.now()); };
    img.src = p.img;
    return card;
  }

  function drawCard(c, t) {
    var g = c.ctx, W = SW, H = SH;
    g.fillStyle = "#010803"; g.fillRect(0, 0, W, H);
    if (!c.base) { // loading: noise
      for (var n = 0; n < 160; n++) { g.fillStyle = "rgba(125,255,154," + (Math.random() * 0.4) + ")"; g.fillRect(Math.random() * W, Math.random() * H, 6, 4); }
      return;
    }
    var glitch = c.burst > 0 || (!reduce && Math.random() < 0.035);
    if (c.burst > 0) c.burst--;
    // boot-in: reveal top to bottom
    if (reduce) c.boot = 2;
    else if (c.boot < 1 || c.boot === 1) { c.boot = c.boot === 1 ? 0.02 : Math.min(1.01, c.boot + 0.06); }
    var reveal = c.boot >= 1 ? H : c.boot * H;
    if (reveal >= H) c.boot = 2;
    g.drawImage(c.base, 0, 0, W, reveal, 0, 0, W, reveal);
    if (glitch && !reduce) {
      var slices = 2 + ((Math.random() * 4) | 0);
      for (var k = 0; k < slices; k++) {
        var y = (Math.random() * H) | 0, h = 8 + ((Math.random() * 44) | 0), dx = ((Math.random() - 0.5) * 72) | 0;
        g.drawImage(c.base, 0, y, W, h, dx, y, W, h);
      }
      g.globalCompositeOperation = "lighter"; g.globalAlpha = 0.35;
      g.drawImage(c.base, 6, 0); g.globalAlpha = 1; g.globalCompositeOperation = "source-over";
    }
    // rolling refresh band
    if (!reduce) {
      var by = ((t * 0.06 + c.seed * 30) % (H + 120)) - 60;
      var grd = g.createLinearGradient(0, by - 60, 0, by + 60);
      grd.addColorStop(0, "rgba(125,255,154,0)"); grd.addColorStop(0.5, "rgba(125,255,154,.13)"); grd.addColorStop(1, "rgba(125,255,154,0)");
      g.fillStyle = grd; g.fillRect(0, by - 60, W, 120);
    }
    // scanlines + vignette
    g.fillStyle = "rgba(0,0,0,.32)";
    for (var s = 0; s < H; s += 4) g.fillRect(0, s, W, 1.5);
    var v = g.createRadialGradient(W / 2, H / 2, H * 0.25, W / 2, H / 2, H * 0.72);
    v.addColorStop(0, "rgba(0,0,0,0)"); v.addColorStop(1, "rgba(0,0,0,.65)");
    g.fillStyle = v; g.fillRect(0, 0, W, H);
  }

  var last = 0;
  function loop(t) {
    if (!cards.length) { running = false; return; }
    requestAnimationFrame(loop);
    if (!visible || document.hidden || t - last < 66) return;  // ~15 fps, film-era refresh
    last = t;
    cards.forEach(function (c) { drawCard(c, t); });
  }
  if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(wrap);

  window.MotherSuggest = {
    show: function (types, title, extra) {
      return load().then(function () { return refreshLive(types); }).then(function () {
        var items = pick(types, 4);
        if (!items.length) { wrap.hidden = true; return; }
        grid.innerHTML = ""; cards = items.map(makeCard);
        cards.forEach(function (c) { grid.appendChild(c.el); });
        head.textContent = title || "DADDY RECOMMENDS";
        if (extra && more) { more.textContent = "[ " + extra.text + " ]"; more.href = extra.href; more.hidden = false; }
        else if (more) more.hidden = true;
        wrap.hidden = false;
        window.MotherSound && MotherSound.alert();
        if (reduce) cards.forEach(function (c) { c.boot = 2; });
        if (!running) { running = true; requestAnimationFrame(loop); }
        if (reduce) setTimeout(function () { cards.forEach(function (c) { drawCard(c, 0); }); }, 600);
      }).catch(function () { wrap.hidden = true; });
    }
  };
})();
